import { useCopilot } from '../../api/copilot';
import { NO_CAPTION, tail } from './util';

/**
 * The words being spoken right now, before either side's line is final.
 *
 * The user's line is the best proof the microphone works: it shows up grey and
 * italic while they talk, where their bubble is about to land, and becomes that
 * bubble once the transcript is final. The agent's caption is the sentence its
 * voice is on, which matters when the audio is muted or the reply arrived only
 * as speech.
 *
 * Both are hidden from assistive technology. A partial transcript rewrites
 * itself several times a second, and a live region announcing each rewrite
 * would drown the finished lines the thread's log region reads out; the
 * thread's status region says "listening" and "speaking" instead.
 */
export default function LiveCaption() {
  const { caption = NO_CAPTION } = useCopilot();
  const user = String(caption?.user ?? '').trim();
  const agent = String(caption?.agent ?? '').trim();
  if (!user && !agent) return null;

  return (
    <>
      {user && (
        <div className="msg usr cp-pending" aria-hidden="true">
          {tail(user, 280)}
        </div>
      )}
      {agent && (
        <div className="cp-caption" aria-hidden="true">
          {tail(agent, 180)}
        </div>
      )}
    </>
  );
}
